import React from "react";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import ServicesManager from "../../../components/ServicesManager";
import { useSetup } from "../hooks/useSetup";

import {
  KoraxOnboardingShell,
  KoraxOnboardingContent,
  KoraxOnboardingFooter
} from "../../../components/KoraxUI/Onboarding";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    maxWidth: 1040
  },

  info: {
    marginTop: 16,
    padding: 14,
    borderRadius: 12,
    color: theme.palette.text.secondary,
    background: "rgba(21,94,239,.06)"
  }
}));

export default function SchedulingServicesStep() {
  const classes = useStyles();
  const { nextStep, previousStep } = useSetup();

  return (
    <KoraxOnboardingShell step={5} totalSteps={10}>
      <KoraxOnboardingContent
        eyebrow="Serviços disponíveis"
        title="Quais serviços seus clientes poderão agendar?"
        description="Cadastre os serviços, a duração de cada atendimento e selecione os profissionais responsáveis."
      >
        <div className={classes.container}>
          <ServicesManager />

          <div className={classes.info}>
            <Typography variant="body2">
              Você poderá editar serviços, valores, duração e profissionais posteriormente na Agenda da Korax.
            </Typography>
          </div>
        </div>
      </KoraxOnboardingContent>

      <KoraxOnboardingFooter
        onBack={previousStep}
        onNext={nextStep}
        nextLabel="Continuar"
      />
    </KoraxOnboardingShell>
  );
}
